import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
// import {CKEditor} from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "ckeditor4-react";
import { useHistory } from "react-router-dom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles

import ImagePreview from "../ImagePreview/ImagePreview";
import useRequest from "../../hooks/useRequest";
import { toast } from "react-toastify";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { useLoadScript } from "@react-google-maps/api";

const libraries = ["places"];

const Edit = (props) => {
  const { id: recordId } = props.match.params;
  const history = useHistory();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDaQcyEyDvVeB8GG3NOzqtXB1i8ukYqcgs",
    libraries,
  });
  const { response, request } = useRequest();
  const { response: responseUpdate, request: requestUpdate } = useRequest();
  const { request: requestCities, response: responseCities } = useRequest();

  const [cities, setCities] = useState([]);
  const [touchedError, setTouchedError] = useState(false);
  const [displayImage, setDisplayImage] = useState();
  const [image, setImage] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [ckcontent, setCkContent] = useState();
  const [address, setAddress] = useState("");
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [openTime, setOpenTime] = useState("");
  const [closeTime, setCloseTime] = useState("");
  const [weekDay, setWeekDay] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    control,
    clearErrors,
  } = useForm();
  const [description, setDescription] = useState(getValues("description"));

  const handleEditorChange = (content) => {
    setDescription(content);
    setValue("description", content); // update form value
    clearErrors("description"); // clear validation errors
  };
  useEffect(() => {
    document.title = "Edit City Attraction - Sportyfy";
    requestCities("GET", "admin/vendor/getCity");
    register("description", {
      required: true,
    });
    request("GET", `admin/vendor/getEventAttractionDetail?dataId=${recordId}`);
  }, [recordId]);

  useEffect(() => {
    if (responseCities) {
      if (responseCities.status && responseCities.data) {
        setCities(responseCities.data);
      }
    }
  }, [responseCities]);
  useEffect(() => {
    if (response) {
      if (response.status && response.data) {
        setValue("city", response.data.cityId);
        setValue("title", response.data.title);
        setValue("description", response.data.description);
        setImage(response.data?.image[0]);
        setSelectedCity(response.data.cityId);
        setCkContent(response.data.description);
        setDescription(response.data.description);
        setAddress(response.data.address || "");
        setLat(response.data.latitude || "");
        setLong(response.data.longitude || "");
        setOpenTime(response.data.openTime || "");
        setCloseTime(response.data.closeTime || "");
        setWeekDay(response.data.weekDay || "");
        setValue("address", response.data.address || "");
        setValue("latitude", response.data.latitude || "");
        setValue("longitude", response.data.longitude || "");
        setValue("openTime", response.data.openTime || "");
        setValue("closeTime", response.data.closeTime || "");
        setValue("weekDay", response.data.weekDay || "");
      }
    }
  }, [response]);

  const onSubmit = (data) => {
    const {
      city,
      title,
      description,
      address,
      latitude,
      longitude,
      openTime,
      closeTime,
      weekDay,
    } = data;
    const formData = new FormData();
    formData.append("cityId", city);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("address", address);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    formData.append("openTime", openTime);
    formData.append("closeTime", closeTime);
    formData.append("weekDay", weekDay);
    formData.append("type", "city_attraction");
    formData.append("dataId", recordId);

    if (displayImage) {
      if (data.image) {
        formData.append("image", data.image);
      }
    } else {
      if (image == null || image == "undefined") {
        formData.append("oldImage", "");
      } else {
        formData.append("oldImage", image);
      }
    }

    requestUpdate("POST", "admin/vendor/editCityEventAttraction", formData);
  };

  useEffect(() => {
    if (responseUpdate) {
      if (responseUpdate.status && responseUpdate.data) {
        toast.success(responseUpdate.message);
        history.push("/city-attractions");
      }
    }
  }, [responseUpdate]);

  const handleImage = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      setDisplayImage(URL.createObjectURL(event.target.files[0]));
      setError("image", "");
      setValue("image", event.target.files[0]);
    } else {
      setDisplayImage("");
      setImage("");
      setValue("image", "");
    }
  };

  const handleRemoveImage = () => {
    if (document.getElementById("image")) {
      document.getElementById("image").value = "";
    }
    setDisplayImage(null);
    setValue("image", null);
    setImage("");
  };

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    setLat(latLng.lat);
    setLong(latLng.lng);
    setAddress(value);
    setValue("address", value);
    setValue("latitude", latLng.lat);
    setValue("longitude", latLng.lng);
  };

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb
            title={"Edit"}
            links={[
              { to: "/dashboard", name: "Home" },
              { to: "/city-attractions", name: "City Attractions" },
            ]}
          />
        </div>
        <div className="col-xl-6 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit City Attraction</h6>
            </div>
            <div className="ms-panel-body">
              <form
                className="needs-validation clearfix"
                noValidate
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="form-row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="city">
                      City<span className="field-required">*</span>
                    </label>
                    <div className="input-group">
                      <select
                        {...register("city", {
                          required: true,
                        })}
                        className={`form-control ${
                          touchedError
                            ? errors.city
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                        }`}
                        id="city"
                      >
                        <option value={""}>Select</option>
                        {cities &&
                          cities.length > 0 &&
                          cities.map((obj) => (
                            <option
                              key={obj._id}
                              selected={
                                obj._id == selectedCity ? "selected" : ""
                              }
                              value={obj._id}
                            >
                              {obj.name}
                            </option>
                          ))}
                      </select>

                      {errors.city?.type === "required" && (
                        <div className="invalid-field">
                          The city field is required.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="title">
                      Title<span className="field-required">*</span>
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        id="title"
                        placeholder="Title"
                        className={`form-control ${
                          touchedError
                            ? errors.title
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                        }`}
                        {...register("title", {
                          required: true,
                        })}
                      />
                      {errors.title?.type === "required" && (
                        <div className="invalid-field">
                          The title field is required.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="address">
                      Address<span className="field-required">*</span>
                    </label>
                    <PlacesAutocomplete
                      value={address}
                      onChange={setAddress}
                      onSelect={handleSelect}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => (
                        <div style={{ position: "relative" }}>
                          <input
                            {...getInputProps({
                              placeholder: "Search Places ...",
                              className: "form-control",
                            })}
                          />
                          <div
                            className="autocomplete-dropdown-container"
                            style={{
                              backgroundColor: "white",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                              position: "absolute",
                              zIndex: 1000,
                              width: "100%",
                            }}
                          >
                            {loading && <div>Loading...</div>}
                            {suggestions.map((suggestion) => {
                              const className = suggestion.active
                                ? "suggestion-item--active"
                                : "suggestion-item";
                              const style = suggestion.active
                                ? {
                                    backgroundColor: "#fafafa",
                                    cursor: "pointer",
                                  }
                                : {
                                    backgroundColor: "#ffffff",
                                    cursor: "pointer",
                                  };
                              return (
                                <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                    <input
                      {...register("address", { required: true })}
                      style={{ display: "none" }}
                    />
                    {errors.address?.type === "required" && (
                      <div className="invalid-field">
                        The address field is required.
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="lat">
                      Latitude<span className="field-required">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="latitude"
                      rules={{ required: true }}
                      render={({ field }) => (
                        <input
                          type="text"
                          id="lat"
                          placeholder="Latitude"
                          className={`form-control ${
                            touchedError
                              ? errors.latitude
                                ? "is-invalid"
                                : "is-valid"
                              : ""
                          }`}
                          {...field}
                          value={lat}
                          onChange={(e) => {
                            setLat(e.target.value);
                            field.onChange(e);
                          }}
                        />
                      )}
                    />
                    {errors.lat?.type === "required" && (
                      <div className="invalid-field">
                        The latitude field is required.
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="long">
                      Longitude<span className="field-required">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="longitude"
                      rules={{ required: true }}
                      render={({ field }) => (
                        <input
                          type="text"
                          id="long"
                          placeholder="Longitude"
                          className={`form-control ${
                            touchedError
                              ? errors.longitude
                                ? "is-invalid"
                                : "is-valid"
                              : ""
                          }`}
                          {...field}
                          value={long}
                          onChange={(e) => {
                            setLong(e.target.value);
                            field.onChange(e);
                          }}
                        />
                      )}
                    />
                    {errors.long?.type === "required" && (
                      <div className="invalid-field">
                        The longitude field is required.
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="openTime">
                      Open Time<span className="field-required">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="openTime"
                      rules={{ required: true }}
                      render={({ field }) => (
                        <input
                          type="time"
                          id="openTime"
                          className={`form-control ${
                            touchedError
                              ? errors.openTime
                                ? "is-invalid"
                                : "is-valid"
                              : ""
                          }`}
                          {...field}
                          value={openTime}
                          onChange={(e) => {
                            setOpenTime(e.target.value);
                            field.onChange(e);
                          }}
                        />
                      )}
                    />
                    {errors.openTime?.type === "required" && (
                      <div className="invalid-field">
                        The open time field is required.
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="closeTime">
                      Close Time<span className="field-required">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="closeTime"
                      rules={{ required: true }}
                      render={({ field }) => (
                        <input
                          type="time"
                          id="closeTime"
                          className={`form-control ${
                            touchedError
                              ? errors.closeTime
                                ? "is-invalid"
                                : "is-valid"
                              : ""
                          }`}
                          {...field}
                          value={closeTime}
                          onChange={(e) => {
                            setCloseTime(e.target.value);
                            field.onChange(e);
                          }}
                        />
                      )}
                    />
                    {errors.closeTime?.type === "required" && (
                      <div className="invalid-field">
                        The close time field is required.
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="weekDay">
                      Week Day<span className="field-required">*</span>
                    </label>
                    <select
                      id="weekDay"
                      className={`form-control ${
                        touchedError
                          ? errors.weekDay
                            ? "is-invalid"
                            : "is-valid"
                          : ""
                      }`}
                      {...register("weekDay", { required: true })}
                      value={weekDay}
                      onChange={(e) => {
                        setWeekDay(e.target.value);
                        setValue("weekDay", e.target.value);
                      }}
                    >
                      <option value="">Select Week Day</option>
                      <option value="allday">Full Week</option>
                      <option value="monday-saturday">Monday-Saturday</option>
                      <option value="monday-friday">Monday-Friday</option>
                    </select>
                    {errors.weekDay && weekDay == "" && (
                      <div
                        className="invalid-field"
                        style={{ position: "initial" }}
                      >
                        The Week Day field is required.
                      </div>
                    )}
                  </div>
                  <div className="col-md-12 mb-3">
                    <label htmlFor="description">
                      Description<span className="field-required">*</span>
                    </label>
                    <div className="input-group mb-5">
                      {ckcontent && (
                        // <CKEditor
                        //     initData={getValues("description")}
                        //     config={{
                        //       extraAllowedContent:
                        //         "p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};i(*)[*]{*}",
                        //       allowedContent: true,
                        //       protectedSource: [/<i[^>]*><\/i>/g],
                        //       // removeEmpty: { i: false },
                        //     }}
                        //     onChange={({ editor }) => {
                        //       const data = editor.getData();
                        //       setValue("description", data);
                        //       clearErrors("description");
                        //     }}
                        //   />

                        <>
                          <ReactQuill
                            theme="snow"
                            value={description}
                            onChange={handleEditorChange}
                            modules={{
                              toolbar: [
                                [
                                  { header: "1" },
                                  { header: "2" },
                                  { font: [] },
                                ],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["bold", "italic", "underline"],
                                ["link", "image"],
                                [{ align: [] }],
                                ["clean"], // remove formatting button
                              ],
                            }}
                          />
                          <textarea
                            {...register("description", { required: true })}
                            style={{ display: "none" }} // hidden textarea to store the value
                          />
                        </>
                      )}

                      {errors?.description?.type === "required" && (
                        <div className="invalid-field">
                          The description field is required.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12 mb-3">
                    <label htmlFor="image"> Image</label>
                    <div className="custom-file">
                      <Controller
                        control={control}
                        name="image"
                        render={({ field: { onChange, value, ref } }) => (
                          <input
                            type="file"
                            id="image"
                            onChange={handleImage}
                            style={{ display: "none" }}
                            inputRef={ref}
                            accept="image/*"
                            className="custom-file-input"
                          />
                        )}
                      />
                      <label className="custom-file-label" htmlFor="image">
                        Images
                      </label>
                      <div className="invalid-feedback">
                        Example invalid custom file feedback
                      </div>
                    </div>
                  </div>

                  <button
                    className="btn btn-primary mt-4 d-block w-100"
                    onClick={() => setTouchedError(true)}
                    type="submit"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {(displayImage || image) && (
          <div className="col-xl-6 col-md-12">
            <div className="row">
              <div className="col-md-12">
                <div className="ms-panel">
                  <div className="ms-panel-header">
                    <h6>Image </h6>
                  </div>
                  <div className="ms-panel-body">
                    <ImagePreview displayImage={displayImage} image={image} />
                  </div>

                  <div className="ms-panel-header ">
                    <label
                      className="btn btn-primary mx-2"
                      onClick={handleRemoveImage}
                    >
                      Remove
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Edit;
